import { Box, Link } from "@planningcenter/tapestry-react"
import Icon from "components/planning_center_icon"
import { node, number, oneOfType, string } from "prop-types"
import { useEffect, useState } from "react"

IntegrationEnabledAlert.propTypes = {
  apiBaseUrl: string,
  eventId: oneOfType([string, number])
}

export function IntegrationEnabledAlert({ apiBaseUrl, eventId }) {
  const [loading, setLoading] = useState(true)
  const [failedLoading, setFailedLoading] = useState(false)

  const [numberOfEvents, setNumberOfEvents] = useState(0)
  const [futureSynced, setFutureSynced] = useState(false)

  useEffect(() => {
    fetch(integrationLinkUrl(apiBaseUrl, eventId), {
      credentials: "include"
    })
      .then(response => response.json())
      .then(json => {
        setNumberOfEvents(json.data.length)
        setFutureSynced(
          json.data.some(link => link.attributes.sync_future_assignment_types === true)
        )
      })
      .catch(() => setFailedLoading(true))
      .finally(() => setLoading(false))
  }, [])

  if (loading) return null
  if (failedLoading)
    return <AlertWrapper>Unable to fetch integration status from Check-Ins</AlertWrapper>
  if (numberOfEvents === 0) return null

  return (
    <AlertWrapper>
      This event is connected to{" "}
      {numberOfEvents === 1 ? "a Check-Ins event" : "multiple Check-Ins events"}.{" "}
      {futureSynced && "All assignments syncing is enabled. "}
      <Link
        href="https://pcocheck-ins.zendesk.com/hc/en-us/articles/25103685567515"
        external
      >
        Learn more
      </Link>
    </AlertWrapper>
  )
}

AlertWrapper.propTypes = {
  children: node
}

function AlertWrapper({ children }) {
  return (
    <Box
      textAlign="center"
      marginBottom={2}
      padding={2}
      backgroundColor="var(--color--neutral-200)"
      borderRadius="3px"
    >
      <Icon
        symbol="logomark#check-ins"
        color="var(--color--product-check-ins-primary)"
        className="p-r"
        style={{ top: "2px " }}
      />{" "}
      {children}
    </Box>
  )
}

function integrationLinkUrl(apiBaseUrl, eventId) {
  const globalId = `gid://registrations/Event/${eventId}`
  return `${apiBaseUrl}/integration_links?where[remote_gid]=${encodeURIComponent(
    globalId
  )}&fields[IntegrationLink]=sync_future_assignment_types`
}
